import React from 'react';

const AppFooter = () => {
    return (
        <footer className="app-footer">
            <div className="container">
                <p>&copy; 2025 Bettrlabs Inc. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default AppFooter;
